import { NgModule } from '@angular/core';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { EmailStatusPipe } from './pipes/email-status.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { DebounceDirective } from './directives/ debounce.directive';
import { CommonModule } from '@angular/common';
import { DragNDropDirective } from './directives/drag-n-drop.directive';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { PermissionBlockDirective } from './directives/permission-block.directive';
import { LocalizedNumericInputDirective } from './directives/localize-numeric-input.directive';
import { MatButtonLoadingDirective } from './directives/mat-button-loading.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    DebounceDirective,
    DragNDropDirective,
    HasPermissionDirective,
    PermissionBlockDirective,
    LocalizedNumericInputDirective,
    MatButtonLoadingDirective,
  ],
  exports: [
    DebounceDirective,
    DragNDropDirective,
    HasPermissionDirective,
    PermissionBlockDirective,
    LocalizedNumericInputDirective,
    MatButtonLoadingDirective,
  ],

  providers: [SafePipe, CapitalizePipe, EmailStatusPipe, TruncatePipe],
})
export class CoreModule {}
